import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
} from 'reactstrap';
import LeftSideContent from './LeftSideContent';
import RightSideContent from './RightSideContent';
import Section from './Section';
import './tracking.css';
import 'font-awesome/css/font-awesome.min.css';
import { getTrackingData } from '../../api/Item/itemApi.js';
import { getOrderById } from '../../api/order/orderApi';

const getIdFromUrl = (pathname) => {
  const parts = pathname.split('/');
  const orderId = parts[2];
  const stockId = parts[3];
  const tripId = parts[4];
  return { orderId, stockId, tripId };
};

const OrderTracking = () => {
  const [trackingData, setTrackingData] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);

  const fetchTrackingData = async () => {
    const { stockId, tripId } = getIdFromUrl(window.location.pathname);
    try {
      const response = await getTrackingData(tripId, stockId);
      const data = response.data.statusArray;
      console.log('tracking data', data);
      setTrackingData(data);
    } catch (error) {
      console.error(
        'Error fetching tracking data:',
        error.response.data.message
      );
    }
  };

  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await getOrderById(orderId);
      const data = response.data;
      console.log('order details', data);
      setOrderDetails(data);
    } catch (error) {
      console.error(
        'Error fetching order details:',
        error.response.data.message
      );
    }
  };

  useEffect(() => {
    const { orderId, stockId, tripId } = getIdFromUrl(window.location.pathname);
    fetchTrackingData();
    if (orderId) fetchOrderDetails(orderId);
  }, []); // Fetch data on component mount

  const formatDate = (minDate) => {
    if (!minDate) return { date: '', time: '' };

    const dateObj = new Date(minDate);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString();

    return { date, time };
  };

  // Derive delivery address and seller details from orderDetails
  const deliveryAddress = orderDetails?.data?.buyerDetails?.[0]?.address
    ? `${orderDetails.data.buyerDetails[0].address.line1}, ${orderDetails.data.buyerDetails[0].address.line2}`
    : 'Loading...';
  const buyerName = orderDetails?.data?.buyerDetails?.[0]
    ? `${orderDetails.data.buyerDetails[0].firstName} ${orderDetails.data.buyerDetails[0].lastName}`
    : 'Loading...';
  const buyerEmail =
    orderDetails?.data?.buyerDetails?.[0]?.email || 'Loading...';
  const buyerPhone =
    orderDetails?.data?.buyerDetails?.[0]?.contactNumber || 'Loading...';
  const sellerName = 'Dilum Thilanka'; // Placeholder
  const sellerEmail = 'dilum@gmail.com'; // Placeholder
  const sellerPhone = '0716020556'; // Placeholder
  const sellerAddress = orderDetails?.data?.Harbour || 'Gandara'; // Using Harbour as a proxy

  // Find the last completed stage
  const lastCompletedStage = trackingData
    .filter((item) => item.status === 'Completed')
    .pop();
  const deliveredStage = lastCompletedStage
    ? lastCompletedStage.stage
    : 'Not Delivered';
  const deliveredStatus = lastCompletedStage
    ? lastCompletedStage.status
    : 'Not Started';
  const deliveredDate = lastCompletedStage?.minDate
    ? new Date(lastCompletedStage.minDate).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : 'Loading...';

  document.title =
    'Candidate Details | Jobcy - Job Listing Template | Themesdesign';

  return (
    <React.Fragment>
      <section
        className="section bg-light"
        style={{ paddingTop: '80px' }}
      >
        <Container
          fluid
          className="gaps"
        >
          <Row>
            <Col
              md={5}
              className="d-flex flex-column"
            >
              <Card className="address mb-4">
                <CardBody>
                  <span className="adTitle">Delivery Address</span>
                  <hr />
                  <span className="adddress">{deliveryAddress}</span>
                </CardBody>
              </Card>

              <Card className="address">
                <CardBody>
                  <span className="adTitle">Seller Details</span>
                  <hr />
                  <ul style={{ listStyleType: 'none', padding: 0 }}>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <i
                        className="fa fa-user"
                        style={{ fontSize: '14px', marginRight: '8px' }}
                      ></i>
                      {sellerName}
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <i
                        className="fa fa-envelope"
                        style={{ fontSize: '14px', marginRight: '8px' }}
                      ></i>
                      {sellerEmail}
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <i
                        className="fa fa-phone"
                        style={{ fontSize: '14px', marginRight: '8px' }}
                      ></i>
                      {sellerPhone}
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <i
                        className="fa fa-map-marker"
                        style={{ fontSize: '14px', marginRight: '8px' }}
                      ></i>
                      {sellerAddress}
                    </li>
                  </ul>
                </CardBody>
              </Card>
            </Col>
            <Col
              md={7}
              className="d-flex flex-column"
            >
              <Card className="tracking-card">
                <CardBody>
                  <CardTitle tag="h5">
                    <div className="title-content">
                      <div className="left-content">
                        <p className="trackingTitle1">Your order is</p>
                        <p className="delivered">
                          {deliveredStage} {deliveredStatus}
                        </p>
                        <p className="trackingStatusDate">on {deliveredDate}</p>
                      </div>
                      <div className="right-content">
                        <span className="orderId">
                          Order ID :{' '}
                          {orderDetails?.data?.Order_id || 'Loading...'}
                        </span>
                      </div>
                    </div>
                  </CardTitle>

                  <div className="tracking-history">
                    <hr />
                    <span className="title1">Tracking history</span>
                    {trackingData.map((item, index) => (
                      <div
                        key={index}
                        className={`tracking-item mt-4 ${
                          item.status ? 'pending' : ''
                        }`}
                      >
                        <div
                          className="tracking-info left"
                          style={{ flex: 1, textAlign: 'left' }}
                        >
                          <div className="tracking-date">
                            {formatDate(item.minDate).date}
                          </div>
                          <div className="tracking-time">
                            {formatDate(item.minDate).time}
                          </div>
                        </div>
                        <div
                          className="tracking-dot-container"
                          style={{
                            flex: 0.1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className={`tracking-dot ${
                              index === 0 ? 'active' : ''
                            }`}
                          ></div>
                        </div>
                        <div
                          className="tracking-info right"
                          style={{ flex: 1, textAlign: 'right' }}
                        >
                          <div className="tracking-date">{item.stage}</div>
                          <div className="tracking-time">{item.status}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default OrderTracking;